import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import Image from '../assets/images/gainservo-logo.png'

const Navbar = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const timeoutRef = useRef(null)
  return (
    <nav className="bg-white shadow-lg fixed top-0 left-0 right-0 z-50">
      <div className="max-w-[1440px] mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center py-4">
            <Link to="/" className="flex items-center">
              <img className="w-48" src={Image} alt="Gainservo" />
            </Link>
          </div>
          
          {/* Menü Items */}
          <div className="hidden lg:flex space-x-8">
            <Link to="/" className="relative text-[#2E3192] hover:text-[#2E3192] transition duration-300 group font-semibold text-lg flex items-center">
              <Icon icon="mdi:home" className="w-5 h-5 mr-2" />
              Ana Sayfa
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#CCDC59] transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <div 
              className="relative"
              onMouseEnter={() => {
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current)
                  timeoutRef.current = null
                }
                setIsServicesOpen(true)
              }}
              onMouseLeave={() => {
                timeoutRef.current = setTimeout(() => {
                  setIsServicesOpen(false)
                }, 300) // 300ms delay
              }}
            >
              <button className="relative text-[#2E3192] hover:text-[#2E3192] transition duration-300 group flex items-center font-semibold text-lg">
                <Icon icon="mdi:briefcase" className="w-5 h-5 mr-2" />
                Hizmetlerimiz
                <svg className="w-4 h-4 ml-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#CCDC59] transition-all duration-300 group-hover:w-full"></span>
              </button>
              
              {/* Dropdown Menu */}
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <Link 
                    to="/repair-maintenance" 
                    className="flex items-center px-4 py-2 text-[#2E3192] hover:bg-[#CCDC59]/10 hover:text-[#CCDC59] transition duration-200"
                  >
                    Tamir/Bakım
                  </Link>
                  <Link 
                    to="/new-product-sales" 
                    className="flex items-center px-4 py-2 text-[#2E3192] hover:bg-[#CCDC59]/10 hover:text-[#CCDC59] transition duration-200"
                  >
                    Yeni Ürün Satışı
                  </Link>
                  <Link 
                    to="/technical-service" 
                    className="flex items-center px-4 py-2 text-[#2E3192] hover:bg-[#CCDC59]/10 hover:text-[#CCDC59] transition duration-200"
                  >
                    Teknik Servis ve Revizyon Devreye Alma
                  </Link>
                </div>
              )}
            </div>
            <Link to="/about-us" className="relative text-[#2E3192] hover:text-[#2E3192] transition duration-300 group font-semibold text-lg flex items-center">
              <Icon icon="mdi:information" className="w-5 h-5 mr-2" />
              Hakkımızda
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#CCDC59] transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link to="/contact-us" className="relative text-[#2E3192] hover:text-[#2E3192] transition duration-300 group font-semibold text-lg flex items-center">
              <Icon icon="mdi:phone" className="w-5 h-5 mr-2" />
              İletişim
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#CCDC59] transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </div>

          {/* İletişim Bilgileri */}
          <div className="hidden lg:flex flex-col items-end text-right">
            <div className="flex items-center text-[#2E3192] text-sm mb-1"> 
              <span>+90 541 396 7820</span>
              <Icon icon="logos:whatsapp-icon" className="w-4 h-4 ml-2" />
            </div>
            <div className="flex items-center text-[#2E3192] text-sm mb-1">
              <span>+90 501 032 5260</span>
              <Icon icon="logos:telegram" className="w-4 h-4 ml-2" />
            </div>
            {/* <div className="flex items-center text-[#2E3192] text-sm">
              <span>info@gainservo.com</span>
              <Icon icon="mdi:email" className="w-4 h-4 ml-2" />
            </div> */}
            <div className="flex items-center text-[#2E3192] text-sm">
              <span>info@gainservo.com</span>
              <Icon icon="mdi:email" className="w-4 h-4 ml-2" />
            </div>
          </div>
          
          {/* Mobil Menü Butonu */}
          <div className="lg:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-[#2E3192] hover:text-[#CCDC59] focus:outline-none transition duration-300"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobil Menü */}
      <div className={`lg:hidden fixed inset-y-0 right-0 w-80 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
        isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="flex flex-col h-full">
          {/* Mobil Menü Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <img className="h-12 w-auto" src={Image} alt="Gainservo" />
            <button 
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-[#2E3192] hover:text-[#CCDC59] transition duration-300"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Mobil Menü Items */}
          <div className="flex-1 px-6 py-8 space-y-6">
            <Link 
              to="/" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 font-semibold text-lg py-2 border-b border-gray-100"
            >
              <Icon icon="mdi:home" className="w-5 h-5 mr-3" />
              Ana Sayfa
            </Link>
            
            {/* Mobil Hizmetler Dropdown */}
            <div className="space-y-2">
              <div className="flex items-center text-[#2E3192] font-semibold text-lg py-2 border-b border-gray-100">
                <Icon icon="mdi:briefcase" className="w-5 h-5 mr-3" />
                Hizmetlerimiz
              </div>
              <div className="pl-4 space-y-3">
                <Link 
                  to="/repair-maintenance" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 text-base py-1"
                >
                  <Icon icon="mdi:wrench" className="w-4 h-4 mr-3" />
                  Tamir/Bakım
                </Link>
                <Link 
                  to="/new-product-sales" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 text-base py-1"
                >
                  <Icon icon="mdi:shopping" className="w-4 h-4 mr-3" />
                  Yeni Ürün Satışı
                </Link>
                <Link 
                  to="/technical-service" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 text-base py-1"
                >
                  <Icon icon="mdi:tools" className="w-4 h-4 mr-3" />
                  Teknik Servis ve Revizyon Devreye Alma
                </Link>
              </div>
            </div>

            <Link 
              to="/about-us" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 font-semibold text-lg py-2 border-b border-gray-100"
            >
              <Icon icon="mdi:information" className="w-5 h-5 mr-3" />
              Hakkımızda
            </Link>

            <Link 
              to="/contact-us" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center text-[#2E3192] hover:text-[#CCDC59] transition duration-300 font-semibold text-lg py-2 border-b border-gray-100"
            >
              <Icon icon="mdi:phone" className="w-5 h-5 mr-3" />
              İletişim
            </Link>
          </div>

          {/* Mobil Menü Footer */}
          <div className="p-6 border-t border-gray-200">
            <div className="space-y-2 text-sm text-[#2E3192]">
              <p className="flex items-center gap-2">
                <Icon icon="logos:whatsapp-icon" className="w-4 h-4" />
                +90 541 396 7820
              </p>
              <p className="flex items-center gap-2">
                <Icon icon="logos:telegram" className="w-4 h-4" />
                +90 501 032 5260
              </p>
              <p className="flex items-center gap-2">
                <Icon icon="mdi:email" className="w-4 h-4" />
                info@gainservo.com
              </p>
              {/* <p className="flex items-center gap-2">
                <Icon icon="mdi:email" className="w-4 h-4" />
                info@gainservo.com
              </p> */}
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </nav>
  )
}

export default Navbar
